/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddRoleToCompany200Response,
  AddRoleToCompanyRequest,
  GetAccountRoles200Response,
  GetCompanyRoleSettings200Response,
  GetCompanyRoles200Response,
  IssueCsrfToken400Response,
  UpdateCompanyRoleRequest,
} from '../models/index';
import {
    AddRoleToCompany200ResponseFromJSON,
    AddRoleToCompany200ResponseToJSON,
    AddRoleToCompanyRequestFromJSON,
    AddRoleToCompanyRequestToJSON,
    GetAccountRoles200ResponseFromJSON,
    GetAccountRoles200ResponseToJSON,
    GetCompanyRoleSettings200ResponseFromJSON,
    GetCompanyRoleSettings200ResponseToJSON,
    GetCompanyRoles200ResponseFromJSON,
    GetCompanyRoles200ResponseToJSON,
    IssueCsrfToken400ResponseFromJSON,
    IssueCsrfToken400ResponseToJSON,
    UpdateCompanyRoleRequestFromJSON,
    UpdateCompanyRoleRequestToJSON,
} from '../models/index';

export interface AddRoleToCompanyOperationRequest {
    addRoleToCompanyRequest?: AddRoleToCompanyRequest;
}

export interface DeleteCompanyRoleRequest {
    roleCode: string;
}

export interface GetAccountRolesRequest {
    permissionCode?: string;
}

export interface GetCompanyRoleSettingsRequest {
    roleCode: string;
}

export interface GetCompanyRolesRequest {
    version?: number;
}

export interface UpdateCompanyRoleOperationRequest {
    roleCode: string;
    updateCompanyRoleRequest?: UpdateCompanyRoleRequest;
}

/**
 * 
 */
export class PermissionApi extends runtime.BaseAPI {

    /**
     * 現在ログインしている企業へ権限を追加します。
     * 企業権限追加
     */
    async addRoleToCompanyRaw(requestParameters: AddRoleToCompanyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddRoleToCompany200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/roles`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddRoleToCompanyRequestToJSON(requestParameters.addRoleToCompanyRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddRoleToCompany200ResponseFromJSON(jsonValue));
    }

    /**
     * 現在ログインしている企業へ権限を追加します。
     * 企業権限追加
     */
    async addRoleToCompany(requestParameters: AddRoleToCompanyOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddRoleToCompany200Response> {
        const response = await this.addRoleToCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 現在ログインしている企業の指定権限の設定内容を削除 ただし、管理者権限は削除できない。
     * 企業権限削除
     */
    async deleteCompanyRoleRaw(requestParameters: DeleteCompanyRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IssueCsrfToken400Response>> {
        if (requestParameters.roleCode === null || requestParameters.roleCode === undefined) {
            throw new runtime.RequiredError('roleCode','Required parameter requestParameters.roleCode was null or undefined when calling deleteCompanyRole.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/roles/{role_code}`.replace(`{${"role_code"}}`, encodeURIComponent(String(requestParameters.roleCode))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IssueCsrfToken400ResponseFromJSON(jsonValue));
    }

    /**
     * 現在ログインしている企業の指定権限の設定内容を削除 ただし、管理者権限は削除できない。
     * 企業権限削除
     */
    async deleteCompanyRole(requestParameters: DeleteCompanyRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IssueCsrfToken400Response> {
        const response = await this.deleteCompanyRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 現在ログインしているアカウントの権限設定を取得
     * アカウント権限情報取得
     */
    async getAccountRolesRaw(requestParameters: GetAccountRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccountRoles200Response>> {
        const queryParameters: any = {};

        if (requestParameters.permissionCode !== undefined) {
            queryParameters['permission_code'] = requestParameters.permissionCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/account/roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAccountRoles200ResponseFromJSON(jsonValue));
    }

    /**
     * 現在ログインしているアカウントの権限設定を取得
     * アカウント権限情報取得
     */
    async getAccountRoles(requestParameters: GetAccountRolesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccountRoles200Response> {
        const response = await this.getAccountRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 現在ログインしている企業の指定権限の設定内容を取得
     * 企業権限取得
     */
    async getCompanyRoleSettingsRaw(requestParameters: GetCompanyRoleSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompanyRoleSettings200Response>> {
        if (requestParameters.roleCode === null || requestParameters.roleCode === undefined) {
            throw new runtime.RequiredError('roleCode','Required parameter requestParameters.roleCode was null or undefined when calling getCompanyRoleSettings.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/roles/{role_code}`.replace(`{${"role_code"}}`, encodeURIComponent(String(requestParameters.roleCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompanyRoleSettings200ResponseFromJSON(jsonValue));
    }

    /**
     * 現在ログインしている企業の指定権限の設定内容を取得
     * 企業権限取得
     */
    async getCompanyRoleSettings(requestParameters: GetCompanyRoleSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompanyRoleSettings200Response> {
        const response = await this.getCompanyRoleSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 現在ログインしている企業で定義されている権限を取得
     * 企業権限一覧
     */
    async getCompanyRolesRaw(requestParameters: GetCompanyRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCompanyRoles200Response>> {
        const queryParameters: any = {};

        if (requestParameters.version !== undefined) {
            queryParameters['version'] = requestParameters.version;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCompanyRoles200ResponseFromJSON(jsonValue));
    }

    /**
     * 現在ログインしている企業で定義されている権限を取得
     * 企業権限一覧
     */
    async getCompanyRoles(requestParameters: GetCompanyRolesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCompanyRoles200Response> {
        const response = await this.getCompanyRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 現在ログインしている企業の指定権限の設定内容を更新。 管理者ステータス true:管理者の権限は更新できません。
     * 企業権限更新
     */
    async updateCompanyRoleRaw(requestParameters: UpdateCompanyRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IssueCsrfToken400Response>> {
        if (requestParameters.roleCode === null || requestParameters.roleCode === undefined) {
            throw new runtime.RequiredError('roleCode','Required parameter requestParameters.roleCode was null or undefined when calling updateCompanyRole.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/roles/{role_code}`.replace(`{${"role_code"}}`, encodeURIComponent(String(requestParameters.roleCode))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCompanyRoleRequestToJSON(requestParameters.updateCompanyRoleRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IssueCsrfToken400ResponseFromJSON(jsonValue));
    }

    /**
     * 現在ログインしている企業の指定権限の設定内容を更新。 管理者ステータス true:管理者の権限は更新できません。
     * 企業権限更新
     */
    async updateCompanyRole(requestParameters: UpdateCompanyRoleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IssueCsrfToken400Response> {
        const response = await this.updateCompanyRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
